import { MobileStaffingView } from "@/utils/models";

/**
 * Which mobile Staffing screen a head nurse gets wherever the gaps-first view is offered: the one they chose for this
 * department, or — when they never chose — the rollout flag's: on opens the gaps-first view, off opens classic.
 *
 * Worked out on every read and never saved, so someone who never chose keeps following the flag: turning it on later
 * still moves them. Saving the flag's answer on a first visit would pin everyone to what the flag said that day.
 */
export const resolveMobileStaffingView = (storedView: MobileStaffingView | null, isRolloutFlagOn: boolean): MobileStaffingView => {
	if (storedView !== null) return storedView;
	// DEFAULT: no choice yet is the state every head nurse starts in; the flag is what decides it, per department.
	return isRolloutFlagOn ? MobileStaffingView.Gaps : MobileStaffingView.Classic;
};
